import React from 'react';

const StatsStrip = () => {
  return (
    <div className="relative -mt-6 mb-6 z-30">
      <div className="w-full overflow-hidden bg-transparent" style={{ paddingTop: '9px', paddingBottom: '9px' }}>
        <div className="animate-marquee whitespace-nowrap inline-block">
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="font-black">50K</span> <span className="text-base md:text-xl">Successful Jumps</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="font-black">7</span> <span className="text-base md:text-xl">Active Jumps Across India</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="font-black">5</span> <span className="text-base md:text-xl">years of Safe Experience</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="text-base md:text-xl">First Inclined Bungy jump of India</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="text-base md:text-xl">Get Free Video With Every Bungy Jump</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="font-black">50K</span> <span className="text-base md:text-xl">Successful Jumps</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="font-black">7</span> <span className="text-base md:text-xl">Active Jumps Across India</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="font-black">5</span> <span className="text-base md:text-xl">years of Safe Experience</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="text-base md:text-xl">First Inclined Bungy jump of India</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
          <span className="text-2xl md:text-3xl text-white mx-3" style={{ fontFamily: 'Gibson, sans-serif' }}>
            <span className="text-base md:text-xl">Get Free Video With Every Bungy Jump</span>
          </span>
          <span className="text-2xl md:text-3xl font-black text-yellow-400 mx-3" style={{ fontFamily: 'Century, serif' }}>•</span>
        </div>
      </div>
    </div>
  );
};

export default StatsStrip;
